var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _vm.loading
            ? [
                _c("pulse-loader", {
                  staticClass: "text-center",
                  attrs: { loading: true, color: _vm.loadingColor },
                }),
              ]
            : [
                _c("div", [
                  _c(
                    "table",
                    { staticClass: "table table-sm" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm.records && _vm.records.length
                        ? _c(
                            "draggable",
                            {
                              attrs: { tag: "tbody" },
                              model: {
                                value: _vm.records,
                                callback: function ($$v) {
                                  _vm.records = $$v
                                },
                                expression: "records",
                              },
                            },
                            _vm._l(_vm.records, function (record) {
                              return _c("tr", { key: record.id }, [
                                _c("td", [
                                  _vm._v(_vm._s(record.order_num) + " "),
                                  _c("i", {
                                    staticClass:
                                      "icon-fa icon-fa-arrows pointer",
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(record.name))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(record.phone))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(record.sum_limit))]),
                              ])
                            }),
                            0
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("№")]),
        _vm._v(" "),
        _c("th", [_vm._v("Имя")]),
        _vm._v(" "),
        _c("th", [_vm._v("Телефон")]),
        _vm._v(" "),
        _c("th", [_vm._v("Лимит")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }